<template>
  <DropdownMenuPortal v-if="!context.isMobile">
    <component
      :is="!context.isNested ? DropdownMenuContent : DropdownMenuSubContent"
      v-bind="$attrs"
      :align="props.align ?? (!context.isNested ? 'end' : 'start')"
      :align-offset="!context.isNested ? 0 : -8"
      :side-offset="8"
      :collision-padding="10"
      hide-when-detached
      prioritize-position
      :data-emphasis-identifier="context.id"
      :class="[
        $style.floating_container,
        `z-40 flex max-h-[80dvh] flex-col overflow-y-auto rounded-md border border-transparent bg-gray-900 p-2 text-white shadow-lg transition dark:border-border dark:bg-sidebar`,
      ]"
    >
      <slot />
    </component>
  </DropdownMenuPortal>
  <DrawerPortal v-else>
    <DrawerOverlay class="fixed inset-0 z-40 bg-black/40" />

    <DrawerContent
      v-bind="$attrs"
      class="fixed inset-x-0 bottom-0 z-40 -mx-px flex max-h-[80%] flex-col rounded-t-lg border-x border-t border-transparent bg-gray-900 text-white transition dark:border-border dark:bg-sidebar"
      :data-emphasis-identifier="context.id"
    >
      <DrawerScroller>
        <slot></slot>
      </DrawerScroller>
    </DrawerContent>
  </DrawerPortal>
</template>

<script setup lang="ts">
import {
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuSubContent,
} from "reka-ui";
import { DrawerContent, DrawerOverlay, DrawerPortal } from "vaul-vue";

import { inject } from "./context";
import DrawerScroller from "./internal/DrawerScroller.vue";

defineOptions({
  inheritAttrs: false,
});

const context = inject();

const props = defineProps<{
  align?: "start" | "center" | "end";
}>();
</script>

<style module>
.floating_container {
  transform-origin: var(--reka-dropdown-menu-content-transform-origin);

  @media (prefers-reduced-motion: no-preference) {
    &[data-state="open"] :global {
      animation: pop-in 250ms var(--motion-timing-ease);
    }
    &[data-state="closed"] :global {
      animation: pop-out 250ms var(--motion-timing-ease);
    }
  }
}
</style>
